module.exports = __webpack_public_path__ + "img/2.d30e882a.webp";